// extracted by mini-css-extract-plugin
export default {"root":"_1m0bP","footer":"_24wbK","linkRoot":"_6Y8yX","validationTitle":"_1Wb0W","paymentContainer":"_2f0qE"};